import * as React from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import { RecoilRoot } from 'recoil';
import ReactGA from 'react-ga';
import AdminRouter from './AdminRouter';
import RoasterRouter from './RoasterRouter';
import ProducerRouter from './ProducerRouter';
import WarehouseRouter from './WarehouseRouter';
import TopPage from './TopPage';
import Notification from './Notification';
import NotFoundPage from './NotFoundPage';
import { getCurrentUser } from '../localStorage';
import GlobalDialog from './GlobalDialog';
import CampaignCheckDialog from './organisms/CampaignCheckDialog';
import CookiePolicyPage from './pages/CookiePolicyPage';
var GoooleAnalyticsWrapper = function (_a) {
    var children = _a.children;
    var location = useLocation();
    var currentUser = getCurrentUser();
    React.useEffect(function () {
        if (!TYPICA_GA_TRACKING_ID)
            return function () {
                return;
            };
        ReactGA.initialize(TYPICA_GA_TRACKING_ID);
        if (currentUser.id)
            ReactGA.set({ userId: currentUser.id });
        ReactGA.pageview(location.pathname);
    }, [location]);
    return React.createElement(React.Fragment, null, children);
};
var ScrollToTopAfterPageChange = function (_a) {
    var children = _a.children;
    var location = useLocation();
    React.useLayoutEffect(function () {
        document.documentElement.scrollTop = 0;
    }, [location]);
    return React.createElement(React.Fragment, null, children);
};
var Router = function () {
    return (React.createElement(GoooleAnalyticsWrapper, null,
        React.createElement(ScrollToTopAfterPageChange, null,
            React.createElement(RecoilRoot, null,
                React.createElement(Routes, null,
                    React.createElement(Route, { path: "/admin/*", element: React.createElement(AdminRouter, null) }),
                    React.createElement(Route, { path: "/roaster/*", element: React.createElement(RoasterRouter, null) }),
                    React.createElement(Route, { path: "/producer/*", element: React.createElement(ProducerRouter, null) }),
                    React.createElement(Route, { path: "/warehouse/*", element: React.createElement(WarehouseRouter, null) }),
                    React.createElement(Route, { path: "/cookie-policy", element: React.createElement(CookiePolicyPage, null) }),
                    React.createElement(Route, { path: "/", element: React.createElement(TopPage, null) }),
                    React.createElement(Route, { path: "*", element: React.createElement(NotFoundPage, null) })),
                React.createElement(Notification, null),
                React.createElement(GlobalDialog, null),
                React.createElement(CampaignCheckDialog, null)))));
};
export default Router;
